// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"ec1ed08f","272":"c59c7026","378":"132e3e13","442":"9e080055","454":"d66f71e5","572":"abbfeeee"}[chunkId] + ".chunk.js";
};